// @ts-nocheck
import styled from 'styled-components';

export const VariableSettingsStyled = styled.div`
  padding: 16px;
  background-color: ${props => props.theme.uiColors.background01};

  .variableSettings {
    &__container {
      align-items: center;
      display: flex;
      width: 50%;

      &--expanded {
        width: 100%;
      }
    }

    &__title {
      color: ${props => props.theme.uiColors.selectorLabel};
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeM};
      line-height: 19px;
    }

    &__selector {
      flex: 1;
      margin-left: 16px;

      .singleSelectorComponent__menu {
        z-index: 3;
      }
      .MultipleSelector__WrapperClass {
        z-index: 3;
      }
    }
  }
`;
